export default __webpack_public_path__ + "media/react/gre/pages/essay_review/illustrated-avatars/5-1e16ecf79c891bace4beb63c2499d347.png";